export const getQueryParam = (
  key: string,
  query: Record<string, string | string[]>
) => (Array.isArray(query?.[key]) ? query[key][0] : (query[key] as string));
